export const environment = {
  production: false,
  identifier: 'development',
  apiUrl: '/api/',
  externalAssetUrl: '',

  // AWS COGNITO
  COGNITO_USER_POOL_ID: 'eu-central-1_jWm6h3yti',
  COGNITO_USER_POOL_WEBCLIENT_ID: '490q2ahm9dhqkl2tfesumcq8t5',
  COGNITO_DOMAIN: 'adressmaster-dev.auth.eu-central-1.amazoncognito.com',
  OAUTH_REDIRECT_SIGN_IN: 'http://localhost:4200',
  OAUTH_REDIRECT_SIGN_OUT: 'http://localhost:4200/login',
}
